var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logon"},[_c('div',{staticClass:"tc f24px mat30"},[_vm._v("正在跳转...")])])}]

export { render, staticRenderFns }